import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrackets2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrackets2"><Path d="M8.5 3.5H4.5V12M4.5 12H2.5M4.5 12V20.5H8.5M19.5 12H21.5M19.5 12V3.5H15.5M19.5 12V20.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBrackets2;
